import React from 'react';
import S from '../../UmbracoForm.styles';
const DropDownList = React.forwardRef(({ field, dirty, error, ...otherProps }, ref) => {
    return (React.createElement(S.Field, { className: error?.message && 'invalid', "data-dirty": dirty, "data-invalid": !!error },
        React.createElement(S.Label, { htmlFor: field.alias },
            field.caption,
            React.createElement(S.MandatoryIndicator, null, otherProps.indicator)),
        React.createElement(S.Select, { ref: ref, id: field.alias, placeholder: field.placeholder, required: field.required, ...otherProps },
            React.createElement("option", { value: '' }, field.placeholder),
            field.values?.map((value, index) => {
                const valueCaption = value.split('~|~');
                return (React.createElement("option", { key: `option-${index}`, value: valueCaption[0] }, !valueCaption[1] ? valueCaption[0] : valueCaption[1]));
            })),
        React.createElement(S.Line, null),
        error && React.createElement(S.Error, null, error.message)));
});
DropDownList.displayName = 'DropDownList';
export default DropDownList;
